<template>
    <div>

        <ComundataTablecomp :headers="CarpetaEvaluacionesHeaders" :items="data" :search="search" noResultsText="Sin evaluaciones">
            <template v-slot:fecha="{ item }" >
                {{ item.fecha | filtroFecha }}
            </template>

            <template v-slot:action_hora="{ item }">
                {{ item.hora_inicio | filtroFormatoHora }} - {{ item.hora_fin | filtroFormatoHora }}
            </template>

            <template v-slot:id_estado_evaluacion="{ item }">
                <v-chip small dark class="font-weight-black" :color="item.color_estado">
                    {{ item.estado_evaluacion }}
                </v-chip>
            </template>

            <template v-slot:action_evaluar="{ item }">
                <ButtonComp v-if="'componenteEvento.editar_submodulo'"
                    :disabled="item.id_estado_evaluacion != 1 || (new Date(item.fecha).toISOString().substr(0, 10) != new Date().toISOString().substr(0, 10))"
                    @click="evaluarItem(item)" listButton
                    :tooltipText="'Aplicar evaluación ' + item.id_estado_evaluacion" />

            </template>

            <template v-slot:action_ver="{ item }">
                <ButtonComp v-if="'componenteEvento.editar_submodulo'" :disabled="item.id_estado_evaluacion != 5"
                    @click="verItem(item)" verButton tooltipText="Ver evaluación"/>
                
            </template>



            <template v-slot:action_nota="{ item }">

                <v-tooltip bottom color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                        <v-chip v-if="item.tipo_calificacion == 'L' && item.id_estado_evaluacion == 5" id_estado_evaluacion
                            color="green" v-on="on" class="texto_white" label>{{ item.literal
                            }}</v-chip>
                        <v-chip v-else-if="item.tipo_calificacion == 'N' && item.id_estado_evaluacion == 5" color="green"
                            v-on="on" class="texto_white" label>{{ item.nota_alumno }} {{
                                item.tipo_calificacion }}</v-chip>
                        <v-chip v-else color="green" v-on="on" class="texto_white" label> - </v-chip>
                    </template>

                    <span>Nota de la evaluación</span>
                </v-tooltip>
            </template>
        </ComundataTablecomp>


        <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @reloadComp="reloadComp"
            @close="closeComp">
        </component>
    </div>
</template>

<script>
// import axios, { API_URL } from "@/helpers/axios";
import { mapMutations } from "vuex"; // mapGetters, mapActions
import VisorEvaluacionComp from '@/views/Evaluacion/VisorEvaluacion/visorEvaluacion'
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import { CarpetaEvaluacionesHeaders } from '../../../helpers/headersTable';
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';



export default {
    name: 'MisEvaluaciones',
    props: ["dataAreasEval", "listPeriodo", "filter", "data"],
    components: { VisorEvaluacionComp, ComundataTablecomp, ButtonComp },



    data() {
        return {

            // data: [],
            search: '',
            CarpetaEvaluacionesHeaders,
            parametroComp: {},

            compName: null,

            estadoComponente: true,


        }
    },

    // computed: {
    //       ...mapGetters('login', ['componenteEvento'])

    //   },

    methods: {
        // enroll(log) {
        //   console.log("se imprime", log);
        // },

        limpiarForm() {

            // this.filter = {
            //     id_colegio: this.datoLogin.id_colegio,
            //     id_ano_lectivo: this.datoLogin.id_ano_lectivo,
            //     id_alumno: '',
            //     id_area: '',
            //     id_curso: '',
            //     id_seccion: ''
            // }

            // this.paramComponente = {}
            this.estadoComp = false
        },

        async loadMain() {
            // console.log(`loadMain (evaluacion.vue)`)
            this.limpiarForm()
            // await this.getUserAlumno(this.datoLogin.id)
            // this.getEvaluacionAlumno(this.filter)
            this.emitEvent()
        },

        emitEvent() {
            this.$emit('updateMisEvaluaciones');
        },

        verItem(items) {

            //   console.log(` alum items: `, items)
            let params = {
                id_evaluacion: items.id_evaluacion,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_alumno: items.id_alumno,
                duracion_evaluacion: items.duracion_evaluacion
            }
            //   console.log("LOS PARAMS DE VERITEM")
            //   console.log(params)

            // qualifyAlumno
            let dataquery = { evento: "qualifyAlumno", items: params }
            this.parametroComp = dataquery
            //   console.log(` verItem(): params: `, dataquery)
            this.compName = "VisorEvaluacionComp"
            this.estadoComponente = true

        },

        /*******cerrar modal y blanquear arreglos */
        closeComp() {
            // console.log(`closeComp *alumnoEval*`)
            this.estadoComponente = false
            this.parametroComp = {}
            this.loadMain()
        },



        reloadComp() {
            console.log('reloadComp')
        },

        // async getEvaluacionAlumno(filter) {
        //         try {
        //             let response = await axios.post(`/evaluacion/alumnos/view/`, { filter })
        //             this.data = response.data
        //             console.log("LA DATA QUE SE RELLENA EN THIS.DATA OSEA ACA DEBE ESTAR LA RESPUESTA gaa")
        //             console.log(this.data)
        //             if (this.data.length == 0) {
        //                 this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros gaa`, tiempo: null })
        //             }
        //         } catch (error) {
        //             console.log(error)
        //             this.setEnviarMens({ tipo: "E", mensaje: error, tiempo: null })
        //         }

        //     },


        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

    },





}
</script>
